<template>
  <div class="homepage_wrap" :onclick="close">
    <div class="popBG">
      <div class="text1">售前咨询和方案定制</div>
      <div class="text2">我们提供免费售前咨询和方案定制，请通过下方电话或企业微信联系我们获取详细产品和方案。</div>

      <div class="item">
        <div class="item-call">
          <img src="../assets/img/call1.png"/>
          <div class="text3">15611406538</div>
        </div>
        <div class="item-call">
          <img :style="{'margin-top':'-40px'}" src="../assets/img/line1.png"/>
        </div>
        <div class="item-call">
          <img src="../assets/img/call2.png"/>
          <div class="text4">添加微信</div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import routerCom from './routerCom.vue'
export default {
  name: 'callWe',
  components:{
    routerCom,
  },
  props: {
    closePop:Function
  },
  methods: {
    close(){
      this.closePop(false);
    }
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.homepage_wrap {
  position: fixed;
  right: 0;
  top: 0;
	width: 100%;
  height: 100%;
  background-color: #00000099;

}

.popBG{
  width: 800px;
  height: 500px;
  border-radius: 4px;
  background: #FFFFFF;
  margin: auto;
  position: absolute;
  left: 30%;
  right: 30%;
	top: 25%;
  text-align: center;
}

.text1{
  font-family: Noto Sans SC;
  font-size: 32px;
  font-weight: 500;
  line-height: 32px;
  text-align: center;
  color: #131313;
  margin-top: 100px;
}

.text2{
  width: 550px;
  margin: 30px auto;
  font-family: Noto Sans SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  color: #9E9E9E;
}

.text3{
  font-family: Noto Sans SC;
  font-size: 24px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: #131313;
  margin-top: 20px;
}

.text4{
  margin:auto;
  font-family: Noto Sans SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  color: #9E9E9E;
}

.item{
  display: flex;
  width: 452px;
  height: 122px;
  margin: 70px auto;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.item .item-call{
  width: 160px;
  height: 122px;
  padding: 16px 0px 16px 0px;
}

</style>
